<template>

    <div class="container"
         @mousedown.capture="mousedownShelf"
         @mousemove="mousemove"
         @mouseup="mousePositionBaked = null"
         :style="containerStyle"
    >

        <div class="change-view">
            Вид:
            <div class="view" v-for="view in cameraViews"
                 v-bind:class="{ active: (view.id === currentCameraView) }"
                 @click.prevent="currentCameraView = view.id"
            >{{view.title}}
            </div>

            Zoom:
            <div class="view" v-for="zoom in cameraZooms"
                 v-bind:class="{ active: (zoom.value === currentCameraZoom) }"
                 @click.prevent="previousCameraZoom = currentCameraZoom;  currentCameraZoom = zoom.value"
            >{{zoom.title}}
            </div>

            Верхняя полка:
            <div class="view" @click.prevent="topSideIsVisible = true" :class="{ active: topSideIsVisible }">Вкл</div>
            <div class="view" @click.prevent="topSideIsVisible = false" :class="{ active: !topSideIsVisible }">Выкл</div>

            Нижняя полка:
            <div class="view" @click.prevent="bottomSideIsVisible = true" :class="{ active: bottomSideIsVisible }">Вкл
            </div>
            <div class="view" @click.prevent="bottomSideIsVisible = false" :class="{ active: !bottomSideIsVisible }">Выкл
            </div>

            <br>





        </div>

        <div id="canvas"></div>

        <div id="shelf"
             class="shelf"
             v-bind:style="shelfStyle"
             @mouseup="mouseup"
             @mouseleave="mouseleave"
             title=""
        >

            <svg xmlns="http://www.w3.org/2000/svg"
                 version="1.1"
                 id="backgroundimage"
                 name="backgroundimage"
                 :view-box.camel="viewbox"
                 :style="bottomSide"
                 class="extra-background"
            >
                <g fill="none">
                    <polygon id="Path" stroke="#F79700" stroke-width="2" :points="shelfContour"></polygon>
                </g>
            </svg>

            <div class="side bottom" :style="bottomSide"  v-if="bottomSideIsVisible"></div>
            <div class="side left" :style="leftSide"></div>
            <div class="side right" :style="rightSide"></div>
            <div class="side top" :style="topSide" v-if="topSideIsVisible"></div>

            <pack v-for="(pack, id) in packs"
                  :initWidth="pack.width"
                  :initHeight="pack.initHeight"
                  :initDepth="pack.initDepth"
                  v-bind:initFrontImg="pack.initFrontImg"
                  v-bind:initBackImg="pack.initBackImg"
                  v-bind:initTopImg="pack.initTopImg"
                  v-bind:initRightImg="pack.initRightImg"
                  v-bind:initLeftImg="pack.initLeftImg"
                  v-bind:initBottomImg="pack.initBottomImg"
                  :dominantColor="pack.dominantColor"
                  :isMirrored="pack.isMirrored"
                  v-bind:initPos="pack.pos"
                  :isDraggable="true"
                  :id="id"
                  :x="pack.x"
                  :y="pack.y"
                  :z="pack.z"
                  :zoom="currentCameraZoom"
                  :zIndex="pack.zIndex"
                  :selected="pack.selected"
                  :screenshot="screenshot"

                  @sizeCalcutated="packSizeCalculated"

                  :key="id"
            ></pack>

        </div>
    </div>

</template>


<script type="text/javascript">
  /* eslint-disable no-unused-vars, eslint-disable max-len, no-mixed-operators, no-param-reassign, max-len */
  import Vue from 'vue';
  import axios from 'axios';
  import html2canvas from 'html2canvas';

  export default {
    name: 'shelf',
    props: {
      id: {
        type: String,
        required: true,
      },
      x: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data() {
      return {
        packs: [],
        whatToMove: null,
        groupToMove: [],
        zIndex: 0,
        spaceIsPressed: false,
        mousePositionBaked: null,
        diffX: 0,
        diffY: 0,
        left: 0,
        top: 0,
        currentCameraView: 'right',
        screenshot: false,
        cameraViews: {
          right: { title: 'Справа', id: 'right', rotationX: -20, rotationY: -20 },
          top: { title: 'Сверху', id: 'top', rotationX: -91, rotationY: 0 },
          back: { title: 'Сзади', id: 'back', rotationX: 0, rotationY: 180 },
          front: { title: 'Фронт', id: 'front', rotationX: -10, rotationY: 0 },
          leftBottom: { title: 'Слева снизу', id: 'leftBottom', rotationX: 20, rotationY: 20 },
        },
        currentCameraZoom: 2,
        previousCameraZoom: 2,
        cameraZooms: {
          right: { title: '25%', value: 1 },
          top: { title: '50%', value: 2 },
          back: { title: '75%', value: 3 },
          front: { title: '100%', value: 4 },
        },
        shelfContour: '',
        shelfWidth: 0,
        shelfHeight: 0,
        shelfContourMaxX: 0,
        shelfContourMaxY: 0,
        initWidth: 0,
        initHeight: 0,
        initDepth: 0,
        topSideIsVisible: true,
        bottomSideIsVisible: true,
      };
    },
    watch: {
      currentCameraZoom(newCameraZoom) {
        this.packs.forEach((pack) => {
          pack.x = pack.x / this.previousCameraZoom * newCameraZoom;
          pack.y = pack.y / this.previousCameraZoom * newCameraZoom;
          pack.z = pack.z / this.previousCameraZoom * newCameraZoom;
        });
      },
    },
    methods: {
      loadShelf() {
        const that = this;
        axios.get(`/api/v2/shelfs/${this.id}/`).then((response) => {
          that.isLoading = false;
          this.makeShelf(response.data);
        });
      },
      makeShelf(response) {
        this.$store.commit('shelf', response);
        this.packs = [];

        this.initWidth = response.rack.prototype.width;
        this.initHeight = (response.rack.prototype.height
          - response.rack.prototype.firstShelfY)
          / response.rack.prototype.shelfCount;
        this.initDepth = response.rack.prototype.depth;

        this.shelfContour = response.rack.prototype.contour
          .map((element) => {
            this.shelfContourMaxX = Math.max(this.shelfContourMaxX, element.x);
            this.shelfContourMaxY = Math.max(this.shelfContourMaxY, element.y);
            return `${element.x} ${element.y}`;
          }).join(' ');

        this.shelfWidth = response.rack.prototype.width;
        this.shelfHeight = response.rack.prototype.depth;

        if (response.items.length > 0) {
          response.items.forEach((element, key) => {
            let photos = {};

            if (element.product.photos.length > 0) {
              photos = Object.assign(...element.product.photos.map(
                o => ({ [o.side]: o.photo400 }),
              ));
            } else {
              photos = {
                FRONT: '',
                BACK: '',
                TOP: '',
                RIGHT: '',
                LEFT: '',
                BOTTOM: '',
              };
            }
            const pack = {
              pos: (element.orientation === 'DEFAULT' ? 0 : 1),
              width: element.product.width,
              initHeight: element.product.height,
              initDepth: element.product.depth,
              initFrontImg: photos.FRONT || '',
              initBackImg: photos.BACK || '',
              initTopImg: photos.TOP || '',
              initRightImg: photos.RIGHT || '',
              initLeftImg: photos.LEFT || '',
              initBottomImg: photos.BOTTOM || '',
              dominantColor: element.product.dominantColor || '',
              isMirrored: false,
              x: element.x,
              y: element.y,
              z: element.z,
              zIndex: 1,
              product: element.product.id,
              selected: false,
              size: {},
              existedId: element.id,
              existed: true,
            };

            this.packs.push(pack);
          });
        }
      },
      spacePressed(e) {
        if (e.keyCode === 32) {
          if (e.target.tagName.toUpperCase() === 'BODY') {
            e.preventDefault();
            this.spaceIsPressed = true;
            this.whatToMove = null;
          }
        }
      },
      spaceUp(e) {
        if (e.keyCode === 32) {
          this.spaceIsPressed = false;
          this.mousePositionBaked = null;
        }
      },
      mousedownShelf(e) {
        if (this.spaceIsPressed) {
          e.stopPropagation();
          this.mousePositionBaked = {
            x: e.pageX,
            y: e.pageY,
            shelfLeft: this.left,
            shelfTop: this.top,
          };
        }
      },
      mousedownPack(e) {
        // if (this.whatToMove === null) {
        this.whatToMove = e;
        // } else {
        //   this.whatToMove = null;
        // }
      },
      mousemove(e) {
        if (this.whatToMove !== null) {
          if (this.whatToMove.side === 'front') {
//

            if (this.groupToMove.length === 0) {
              this.groupToMove.push(this.whatToMove);
            }

            let yChange = 0;
            let xChange = 0;

            this.groupToMove.filter(pack => pack.id === this.whatToMove.id).forEach((pack) => {
              const topSidePos = e.clientY - this.whatToMove.offsetY;
              const maxTopSidePos = this.height - this.packs[this.whatToMove.id].size.height;

              const leftSidePos = e.clientX - this.whatToMove.offsetX;
              const maxLeftSidePos = this.width - (this.packs[this.whatToMove.id].size.width);

              const yNewPos = Math.max(0, Math.min(topSidePos, maxTopSidePos));
              const xNewPos = Math.max(0, Math.min(leftSidePos, maxLeftSidePos));

              yChange = this.packs[this.whatToMove.id].y - yNewPos;
              xChange = this.packs[this.whatToMove.id].x - xNewPos;

              this.$set(this.packs[this.whatToMove.id], 'y', yNewPos);
              this.$set(this.packs[this.whatToMove.id], 'x', xNewPos);
            });

            this.groupToMove.filter(pack => pack.id !== this.whatToMove.id).forEach((pack) => {
              this.$set(this.packs[pack.id], 'y', this.packs[pack.id].y - yChange);
              this.$set(this.packs[pack.id], 'x', this.packs[pack.id].x - xChange);
            });
          } else {
            this.packs[this.whatToMove.id].z = Math.min(0, e.clientY - this.whatToMove.offsetZ);
          }
        } else if (this.spaceIsPressed && this.mousePositionBaked !== null) {
          this.left = this.mousePositionBaked.shelfLeft - (this.mousePositionBaked.x - e.pageX);
          this.top = this.mousePositionBaked.shelfTop - (this.mousePositionBaked.y - e.pageY);
        }
      },
      mouseup(e) {
        this.whatToMove = null;
        if (this.groupToMove.length === 1 && !e.altKey) {
          this.groupToMove = [];
        }
      },
      mouseleave(e) {
        this.whatToMove = null;
      },
      packSizeCalculated(e) {
        this.packs[e.id].size = e.size;
      },
      removePack(ind) {
        this.packs.splice(ind, 1);
      },
      rotate(ind) {
        this.$set(this.packs[ind], 'pos', this.packs[ind].pos === 0 ? 1 : 0);
      },
      addProduct(product) {
        let photos = {};

        if (product.photos.edges.length > 0) {
          photos = Object.assign(...product.photos.edges.map(
            o => ({ [o.node.side]: o.node.photo400 }),
          ));
        } else {
          photos = {
            FRONT: '',
            BACK: '',
            TOP: '',
            RIGHT: '',
            LEFT: '',
            BOTTOM: '',
          };
        }


        const pack = {
          pos: 0,
          width: product.width,
          initHeight: product.height,
          initDepth: product.depth,
          initFrontImg: photos.FRONT || '',
          initBackImg: photos.BACK || '',
          initTopImg: photos.TOP || '',
          initRightImg: photos.RIGHT || '',
          initLeftImg: photos.LEFT || '',
          initBottomImg: photos.BOTTOM || '',
          isMirrored: false,
          x: 0,
          y: 0,
          z: 0,
          zIndex: 1,
          product: product.id,
          selected: false,
          size: {},
          existed: false,
        };

        this.packs.push(pack);
      },
      save() {
       //
      },

      click(e) {
       //
      },
    },
    computed: {
      width() {
        return this.initWidth * this.currentCameraZoom;
      },
      height() {
        return this.initHeight * this.currentCameraZoom;
      },
      depth() {
        return this.initDepth * this.currentCameraZoom;
      },
      shelfStyle() {
        return {
          left: `${this.left}px`,
          top: `${this.top}px`,
          width: `${this.width}px`,
          height: `${this.height}px`,
          transform: `rotateX(${this.cameraViews[this.currentCameraView].rotationX}deg) rotateY(${this.cameraViews[this.currentCameraView].rotationY}deg)`,
          transition: this.screenshot ? 'transform 0s linear' : 'transform 1s linear',
          transformStyle: this.screenshot ? '' : 'preserve-3d',
        };
      },
      containerStyle() {
        return {};
      },
      leftSide() {
        return {
          width: `${this.height}px`,
          height: `${this.depth}px`,
          transform: `translate3d(0, 0,  ${-this.depth}px) rotateY(-90deg) rotateZ(-90deg)`,
        };
      },
      bottomSide() {
        return {
          width: `${this.width}px`,
          height: `${this.depth}px`,
          transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)',
        };
      },
      topSide() {
        return {
          width: `${this.width}px`,
          height: `${this.depth}px`,
          transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)',
        };
      },
      rightSide() {
        return {
          width: `${this.height}px`,
          height: `${this.depth}px`,
          transform: `translate3d(0, 0, ${-this.depth}px) rotateY(90deg) rotateZ(90deg)`,
        };
      },
      viewbox() {
        return `0, 0, ${this.shelfContourMaxX}, ${this.shelfContourMaxY}`;
      },
    },
    created() {
      this.loadShelf();

      window.addEventListener('keydown', this.spacePressed);
      window.addEventListener('keyup', this.spaceUp);

      const that = this;
      this.$parent.$on('addProduct', (product) => {
        this.addProduct(product);
      });

      this.$parent.$on('save', () => {
        that.save();
      });
    },
    destroyed() {
      window.removeEventListener('keydown', this.spacePressed);
      window.removeEventListener('keyup', this.spaceUp);

      this.$parent.$off('addProduct');
      this.$parent.$off('save');
    },
  };
</script>


<style lang="less" scoped>
    .saving {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ccc;
        z-index: 10000;
    }

    .container {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .change-view {
        position: absolute;
        top: 40px;
        left: 20px;
        font-size: 14px;
        z-index: 10;
    }

    .view {
        display: inline-block;
        margin-right: 10px;
        color: #999;

        &.active {
            color: #000;
        }
    }

    .shelf {
        position: relative;
        border: 1px solid #ccc;
        border-width: 0 0 1px 1px;
        left: 30px;
        top: 40px;

        /*perspective: 4000px;*/
        /*perspective-origin: 100% 0;*/
        margin-top: 400px;

        .side {
            position: absolute;
            display: block;
            background: rgba(0, 0, 0, 0.3);
        }

        .right {
            top: 0;
            left: 100%;
            transform-origin: 0 0;
            background: #F4F5F6;
        }

        .left {
            top: 0;
            right: 100%;
            transform-origin: 100% 0;
            background: #F4F5F6;
        }

        .extra-background {
            top: 100%;
            left: 0;
            transform-origin: 0 0;
            position: absolute;
            display: block;
            z-index: 100;
        }

        .bottom {
            top: 100%;
            left: 0;
            transform-origin: 0 0;
            background: linear-gradient(to right, rgba(10, 10, 10, 0.2) 0%, rgba(10, 10, 10, 0.2) 1%, rgba(10, 10, 10, 0) 1%),
            linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 1%, rgba(0, 0, 0, 0) 1%);
            background-color: rgba(0, 0, 0, 0.2);
            background-size: 100px;
        }

        .top {
            top: 0;
            left: 0;
            transform-origin: 0 0;
            background: rgba(0, 0, 0, 0.1);
        }

    }

    .loader {
        position: fixed;
        left: 50%;
        top: 50%;
        margin: -20em 0 0 -20em;
    }

</style>


// WEBPACK FOOTER //
// ShelfView.vue?682f5c70